import { CircularProgress, List, ListItem, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SelectField from "../../../Components/SelectField";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    minWidth: '520px',
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateBusinessUnitDialog = ({
  BshandleClose,
  Bsopen,
  BusinessUnit,
  setBusiness,
  AllEmployee,
  errors,
  createBusinessUnit,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={BshandleClose}
      aria-labelledby="customized-dialog-title"
      open={Bsopen}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={BshandleClose}
      >
        <div className="foundation_header">Create Business Unit</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={BusinessUnit.name}
              onChange={(e) =>
                setBusiness({ ...BusinessUnit, name: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Head of Business Unit</label>
            <SelectField
              name="head_of_unit"
              onChange={(e) =>
                setBusiness({
                  ...BusinessUnit,
                  head_of_unit: e.value,
                })
              }
              options={AllEmployee}
              value={AllEmployee?.find(
                (item) => item?.value === BusinessUnit?.head_of_unit
              )}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={BusinessUnit.description}
              onChange={(e) =>
                setBusiness({ ...BusinessUnit, description: e.target.value })
              }
            />
          </div>

          {/* <div className="Box">
            <label>effective Status</label>
            <select
              name="effectiveStatus"
              value={BusinessUnit.effective_status}
              onChange={(e) =>
                setBusiness({
                  ...BusinessUnit,
                  effective_status: e.target.value,
                })
              }
              id=""
            >
              <option value="">Choose unit</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
            {errors.BsueffectiveStatus && <p>Effective status is required.</p>}
          </div>

          <div className="Box">
            <label>effective Start Date</label>
            <input
              type="date"
              name=""
              id=""
              value={BusinessUnit.effective_start_date}
              onChange={(e) =>
                setBusiness({
                  ...BusinessUnit,
                  effective_start_date: e.target.value,
                })
              }
            />
          </div> */}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={BshandleClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={createBusinessUnit}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditBusinessUnitDialog = ({
  handleEditBsClose,
  editBs,
  BusinessUnit,
  setBusiness,
  AllEmployee,
  errors,
  updateBusinessUnit,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleEditBsClose}
      aria-labelledby="customized-dialog-title"
      open={editBs !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleEditBsClose}
      >
        <div className="foundation_header">Edit Business Unit</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={BusinessUnit.name}
              onChange={(e) =>
                setBusiness({ ...BusinessUnit, name: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Head of Business Unit</label>
            <SelectField
              name="head_of_unit"
              onChange={(e) =>
                setBusiness({
                  ...BusinessUnit,
                  head_of_unit: e.value,
                })
              }
              options={AllEmployee}
              value={AllEmployee?.find(
                (item) => item?.value === BusinessUnit?.head_of_unit
              )}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={BusinessUnit.description}
              onChange={(e) =>
                setBusiness({ ...BusinessUnit, description: e.target.value })
              }
            />
          </div>

          {/* <div className="Box">
            <label>effective Status</label>
            <select
              name="effectiveStatus"
              value={BusinessUnit.effective_status}
              onChange={(e) =>
                setBusiness({
                  ...BusinessUnit,
                  effective_status: e.target.value,
                })
              }
              id=""
            >
              <option value="">Choose unit</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
            {errors.BsueffectiveStatus && <p>Effective status is required.</p>}
          </div>

          <div className="Box">
            <label>effective Start Date</label>
            <input
              type="date"
              name=""
              id=""
              value={BusinessUnit.effective_start_date}
              onChange={(e) =>
                setBusiness({
                  ...BusinessUnit,
                  effective_start_date: e.target.value,
                })
              }
            />
          </div> */}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleEditBsClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={updateBusinessUnit}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteBusinessUnitDialog = ({
  handleDeleteBsClose,
  deleteBs,
  deleteBusinessUnit,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleDeleteBsClose}
      aria-labelledby="customized-dialog-title"
      open={deleteBs !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleDeleteBsClose}
      >
        <div className="foundation_header">Delete Business Unit</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Confirmation">Are you sure?</div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleDeleteBsClose} className="Btn">
            Cancel
          </button>
          <button
            className="Delete_Btn"
            onClick={deleteBusinessUnit}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const ViewBusinessUnitDialog = ({
  handleViewBsClose,
  BsViewopen,
  employee,
}) => {
  return (
    <BootstrapDialog
      onClose={handleViewBsClose}
      aria-labelledby="customized-dialog-title"
      open={BsViewopen !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleViewBsClose}
      >
        <div className="foundation_header">View Business Unit</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <List>
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Name</label>
            <p>{BsViewopen?.name}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Head of Business Unit</label>
            <p>{`${employee?.label}`}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Description</label>
            <p>{BsViewopen?.description}</p>
          </ListItem>
        </List>
      </DialogContent>
    </BootstrapDialog>
  );
};
